<template><!-- 相冊圖 -->
  <div>
    <h3 class="mb-5">Gallery</h3>
    <div>
      <!-- items -->
      <PageCollapse v-for="(item, i) in story.galleries" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">{{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px">
              <h4 class="mb-10px">圖片</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                :dir="dir"></ImgUploader>
            </div>
          </div>
        </template>
      </PageCollapse>
      <!-- 添加 item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加圖片</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    story: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  data: () => ({
    dir: 'story',
  }),
  computed: {
    ...mapState('story', ['story']),
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        visual: '',
      };
      this.story.galleries.push(template);
    },
    deleteItem(item) {
      const index = this.story.galleries.map((i) => i.id).indexOf(item.id);
      this.story.galleries.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.story.galleries.length - 1) {
        this.story.galleries.splice(i, 1);
        this.story.galleries.unshift(item);
        return;
      }
      // item become next index
      this.story.galleries.splice(i, 1);
      this.story.galleries.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      if (i === 0) {
        this.story.galleries.splice(i, 1);
        this.story.galleries.push(item);
        return;
      }
      // item become previous index
      this.story.galleries.splice(i, 1);
      this.story.galleries.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
